import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const DiaryListViewLeftPanelHeaderLoader = props =>{
    return(<>
        {props.count && props.count > 0 && (
                      Array.from({ length: props.count }, (_, i) => (
                        <ContentLoader 
                        key={i+1}
                        speed={2}
                        width={960}
                        height={40}
                        viewBox="0 0 960 40"            
                        backgroundColor="#f3f3f3"
                        foregroundColor="#ecebeb"
                    >
                    <rect x="20" y="12" rx="0" ry="0" width="150" height="30" /> 
                    <rect x="180" y="12" rx="0" ry="0" width="150" height="30" /> 
                    <rect x="530" y="12" rx="0" ry="0" width="280" height="30" /> 
                    <rect x="850" y="12" rx="0" ry="0" width="90" height="30" />
                    </ContentLoader>
                      ))
                  )}</>)
}
